import {
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Dialog as MuiDialog,
	type Theme,
	Typography,
	makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
	closeButton: {
		color: '#fff',
		padding: '0px !important',
	},
	closeIcon: {
		fontSize: 32,
	},
	contentNoPadding: {
		padding: 0,
	},
	dialogContent: {
		padding: 20,
	},
	modalTitle: {
		backgroundColor: theme.palette.primary.main,
	},
	root: {
		zIndex: 3005,
	},
	title: {
		color: '#fff',
		fontWeight: 500,
	},
}));

interface Props {
	open: boolean;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	content: any;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	actions?: any;
	title: string;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	maxWidth: any;
	handleOpen: () => void;
	showCloseIcon?: boolean;
	fullScreen?: boolean;
	noPadding?: boolean;
	disableClose?: boolean;
}

export function Dialog({
	actions,
	content,
	disableClose,
	fullScreen = false,
	handleOpen,
	maxWidth,
	noPadding,
	open,
	showCloseIcon = true,
	title,
}: Props) {
	const classes = useStyles();

	return (
		<MuiDialog
			classes={{ root: classes.root }}
			fullScreen={Boolean(fullScreen)}
			fullWidth
			maxWidth={maxWidth}
			open={open}
		>
			<DialogTitle className={classes.modalTitle}>
				<Grid container justify={'space-between'}>
					<Typography className={classes.title} variant={'h3'}>
						{' '}
						{title}{' '}
					</Typography>

					{showCloseIcon ? (
						<IconButton
							aria-label={'Close'}
							className={classes.closeButton}
							disabled={disableClose}
							onClick={handleOpen}
						>
							<CloseIcon className={classes.closeIcon} />
						</IconButton>
					) : (
						''
					)}
				</Grid>
			</DialogTitle>

			<DialogContent
				className={clsx({
					[classes.dialogContent]: !noPadding,
					[classes.contentNoPadding]: noPadding,
				})}
			>
				{content}
			</DialogContent>

			{actions && <DialogActions>{actions}</DialogActions>}
		</MuiDialog>
	);
}
